/**
 * External dependencies
 */
import React from 'react';
import { Box } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import SectionNav from 'components/section-nav';
import NavTabs from 'components/section-nav/tabs';
import NavItem from 'components/section-nav/item';
import logo from 'assets/images/twc-80x80.webp';

/**
 * Style dependencies
 */
import './styles.scss';

const Navigation = (props) => {
    return (
        <Box>
            <SectionNav>
                <NavTabs>
                    <NavItem selected>
                        <img src={logo} alt='Tower Systems' height={55} width={55}  className='nav_item-applogo'/>
                    </NavItem>
                </NavTabs>
            </SectionNav>
        </Box>
    );
};

export default Navigation;
